import _ from 'lodash'

export default {
    computed: {
        propertyType() {
            return this.$store.getters.propertyTypeById(this.propertyTypeId)
        },
        propertyTypeSettings() {
            let pts = _.get(this.propertyType, 'settings', {})
            if (!_.isObject(pts)) pts = {}
            return pts
        },
    },
}
